fragment SmsEditionLightFragment on SmsEdition {
    id
    name
    htmlUrlPath
    content
    createdTime
    deletedTime
    scheduledTime
    modifiedTime
    status
    optOutText
}
